import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalBroadcastService } from '@azure/msal-angular';
import { BrowserUtils, InteractionStatus } from '@azure/msal-browser';
import { MonitoringService } from '@core/services/monitoring.service';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { filter, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'spark-redirect',
  templateUrl: './redirect.component.html'
})
export class RedirectComponent implements OnInit{
  constructor(private msalBroadcastService: MsalBroadcastService, 
    private router: Router,
    private monitoringService: MonitoringService) {}

  private readonly _destroying$ = new Subject<void>();
  ngOnInit(): void {
    if (!BrowserUtils.isInIframe()){
      this.checkAuthInteractions();
    }       
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  } 

  // This function extracts the url we set in the state to be used in the case of user not being navigated away from this component.
  // This is a workaround for an issue in MSAL library not extracting state from the redirect url and returning prematurely.
  private getNavigateUrlFromStateOnUnsuccessfulRedirection(){
    const hash = window.location.href.split('#').pop();
    if (hash) {
      let stateSplit = hash.split("%7C");
      if (stateSplit.length == 2){
        let secondSplit = stateSplit[1].split('&');
        if (secondSplit.length >= 1){
          return secondSplit[0];
        }  
      }      
    } 

    return null;
  }

  private checkAuthInteractions(): void {
    this.msalBroadcastService.inProgress$
      .pipe(
        filter(
          (status: InteractionStatus) => status === InteractionStatus.None
        ),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {        
        let redirectionUrlFromState = this.getNavigateUrlFromStateOnUnsuccessfulRedirection();
        if (redirectionUrlFromState != null){
          this.monitoringService.logTrace("Initiating a redirection to url extracted from state", {redirectionUrlFromState}, SeverityLevel.Information);
          window.location.href = redirectionUrlFromState
        }
        else{
          this.monitoringService.logTrace("Initiating a redirection to /dashboard", {}, SeverityLevel.Warning);
          this.router.navigate(['/dashboard']);
        }        
      });
  }
}